module.exports = __webpack_public_path__ + "img/Logo.60755d7f.svg";